import {type ReactNode} from 'react'
import HgWYSIWYGContainer from '../_components'

export const ARTICLE_WYSIWYG_TYPE = 'article'
export type ArticleWYSIWYGType = typeof ARTICLE_WYSIWYG_TYPE

const HgArticleWYSIWYGContainer = ({children}: {children: ReactNode}) => {
  return <HgWYSIWYGContainer>{children}</HgWYSIWYGContainer>
}

export default HgArticleWYSIWYGContainer
